import * as React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// Components
import { Button } from '../../../../../../../../components/Button';
import { MaterialIcon } from '../../../../../../../../components/MaterialIcon';

// Context
import { RuleEditorContext } from '../context';

const CustomButton = styled(Button)`
    ${({ round }) =>
        round &&
        css`
            border-radius: 50%;
            width: 3rem;
            height: 3rem;
        `}
`;

const ButtonIcon = styled(MaterialIcon)`
    ${({ nomargin }) =>
        nomargin === 'true' &&
        css`
            margin: 0 !important;
        `}
`;

export const NewPredicateButton = ({
    parentPredicateUuid,
    iconSize,
    showLabel = true,
    stringOnly,
    label,
    buttonProps = {},
    children
} = {}) => {
    const { setEditing } = React.useContext(RuleEditorContext);

    return stringOnly ? (
        <a onClick={() => setEditing(parentPredicateUuid ? `new_${parentPredicateUuid}` : 'new')}>
            {children ?? 'Create New Predicate'}
        </a>
    ) : (
        <CustomButton
            onClick={() => setEditing(parentPredicateUuid ? `new_${parentPredicateUuid}` : 'new')}
            {...(buttonProps ?? {})}
        >
            <ButtonIcon
                icon={'add'}
                color={'#04846D'}
                size={iconSize ?? 18}
                nomargin={(showLabel !== true).toString()}
            />
            {showLabel ? 'New Rule Predicate' : null}
        </CustomButton>
    );
};

NewPredicateButton.propTypes = {
    showLabel: PropTypes.bool,
    stringOnly: PropTypes.bool,
    parentPredicateUuid: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.node,
    buttonProps: PropTypes.object,
    iconSize: PropTypes.number
};
